import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { OfframpService } from '../../services/offramp.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50
  }
};

@Component({
  selector: 'app-edit-offramp-admin-config',
  templateUrl: './edit-offramp-admin-config.component.html',
  styleUrls: ['./edit-offramp-admin-config.component.css']
})
export class EditOfframpAdminConfigDialog {
  element: any = {};
  myForm: any;
  recordId: string = '';

  constructor(
    public dialogRef: MatDialogRef<EditOfframpAdminConfigDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notifSer: NotificationsService,
    public fb: FormBuilder,
    public userService: UserService,
    public offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.element = data.record || {};
    this.recordId = this.element._id || '';

    this.myForm = this.fb.group({
      value: [this.element.value, [Validators.required]],
    });
  }

  saveConfig() {
    const { notif } = defaults;

    if (this.myForm.invalid) {
      this.notifSer.error('Error', 'Please enter a valid value', notif);
      return;
    }

    this.spinnerService.show();

    const formData: any = {
      _id: this.recordId,
      value: this.myForm.value.value,
      _csrf: this.data._csrf
    };

    this.offrampService.updateOfframpAdminConfig(formData).subscribe(
      (response) => {
        this.spinnerService.hide();
        if (response.status || response.success) {
          this.dialogRef.close({ success: true, data: response });
        } else {
          this.notifSer.error('Error', response.message || 'Failed to update config', notif);
        }
      },
      (err) => {
        this.spinnerService.hide();
        this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to update config', notif);
      }
    );
  }

  onCancel() {
    this.dialogRef.close({ success: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-admin-config/edit-offramp-admin-config/edit-offramp-admin-config.component.ts